"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const icon_1 = __importDefault(require("../icon"));
const tooltip_1 = __importDefault(require("../tooltip"));
const { CloseButton } = icon_1.default;
const StyledCloseButton = (0, styled_components_1.default)(CloseButton) `
  min-width: 26px;
`;
const TooltipContainer = styled_components_1.default.div `
  display: none;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translate(-50%, 100%);
  width: 100%;
  z-index: 1;
`;
const StyledChipText = styled_components_1.default.span `
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  white-space: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ChipWrapper = styled_components_1.default.div `
  margin: 5px;
  width: fit-content;
  max-width: 170px;
  display: flex;
  height: 32px;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px;
  border: 1px solid
    ${({ theme, isDisabled }) => isDisabled ? theme.neutral.main : theme.primary.main};
  border-radius: 4px;
  color: ${({ theme }) => theme.text.primary};
  background-color: ${({ theme, isDisabled }) => isDisabled ? theme.white : theme.primary.lighter};
  cursor: pointer;

  &:hover {
    & + ${TooltipContainer} {
      display: block;
    }
  }
`;
const ChipContainer = styled_components_1.default.div `
  position: relative;
  width: fit-content;
`;
const StyledDropdownBody = styled_components_1.default.div `
  width: fit-content;
  position: absolute;
  top: calc(100% - 5px);
  left: 5px;
`;
const RotaChip = (_a) => {
    var { chipText, onClose, onClick, isGroup, isDisabled = false, children } = _a, props = __rest(_a, ["chipText", "onClose", "onClick", "isGroup", "isDisabled", "children"]);
    const theme = (0, styled_components_1.useTheme)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, react_1.useState)(false);
    const [hasTooltip, setHasTooltip] = (0, react_1.useState)(false);
    const dropdownRef = (0, react_1.useRef)(null);
    const textRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setHasTooltip((((_a = textRef === null || textRef === void 0 ? void 0 : textRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) <
            (((_b = textRef === null || textRef === void 0 ? void 0 : textRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth) || 0));
    }, [chipText]);
    const handleClose = (event) => {
        event.stopPropagation();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleClick = (event) => {
        event.stopPropagation();
        if (isGroup) {
            setIsDropdownOpen(!isDropdownOpen);
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    };
    (0, react_1.useEffect)(() => {
        if (isGroup) {
            if (isDropdownOpen) {
                document.addEventListener("mousedown", handleClickOutside);
            }
            else {
                document.removeEventListener("mousedown", handleClickOutside);
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [isDropdownOpen]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (e) => {
        var _a;
        const isClickInside = (_a = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);
        !isClickInside && setIsDropdownOpen(false);
    };
    return (react_1.default.createElement(ChipContainer, Object.assign({}, props, { ref: dropdownRef }),
        react_1.default.createElement(ChipWrapper, { onClick: handleClick, isDisabled: isDisabled, className: "chip-wrapper" },
            react_1.default.createElement(StyledChipText, { ref: textRef }, chipText),
            onClose && !isDisabled && (react_1.default.createElement(StyledCloseButton, { onClick: handleClose, color: theme.primary.main }))),
        hasTooltip && (react_1.default.createElement(TooltipContainer, null,
            react_1.default.createElement(tooltip_1.default, { tooltipText: chipText }))),
        isGroup && isDropdownOpen && (react_1.default.createElement(StyledDropdownBody, null, children))));
};
exports.default = RotaChip;
